import React, { Component } from 'react';
import "../../../CommonStyles/CSS.css"
import { Config } from '../../../Config';


var t = { // transslations
    "EN": {
        "dati": "Card data",
        "textInsertAndPay": "Please insert your credit card informations in order to purchase.",
        "textInsert": "The credit card details are mandatory only to use the Parking service. You can skip this step and enter data later by accessing your user area.",
        "textChange": "Change the card details you want to use for your purchases.",
        "cardCheckInfo": "For card checking you will be charged and immediately refunded 10 cents.",
        "creditCard": "Credit Card",
        "debtCard": "Debit Card",
        "ChangeCreditCard": "Change",
        "InsertCreditCard": "Insert",
        "Pay": "Pay",
        "labelCC": "Credit Card Number",
        "labelExpiry": "MM/YY",
        "labelCVV": "CVV",
        "labelBuyerName": "Name on the card",
        "labelTokenize": "Remember this card",
        "amountLabel": "Temporary Amount: ",
        "paidAmountLabel": "Amount to pay: ",
        "maximumAmountLabel": "Maximum Daily Amount: ",
        "maximumAmountInfo": "The maximum amount will be booked and charged the effective amount of time at the parking's end.",
        "additionalTransactionLabel": "Data Insert for transaction attestation.",
        "attestationBuyerNameLabel": "Name and Surname",
        "emailLabel": "Email*",
        "phoneLabel": "Cellphone*",
        "payAndConfirmParking": "Continue and confirm",
        "payAndConfirm": "Continue and confirm",
        "Submit": "CONFIRM THE CREDIT CARD",
        "pText": "REGISTRATION",
        "pText2": "3/4",
        "Per_Ora": "For now skip this section",
        "InsertInfo": "Once the details of the Credit Card have been inserted, you will be charged, and subsequently canceled, 0.10 &euro; for the verification of the data.",
        "Piu_informazioni": "More information",
        'InsertCreditCardAndPay': 'Insert and pay',
        "NomeCognome": "Name on card",
        "NumberCC": "Card number",
        "specifyCC": "Please insert the number of your card",
        "specifyCVV": "Please insert the CVV of your card",
        "specifyExp": "Please insert the date of expiry of your card",
        "wcl": "Credit card number with wrong length",
        "wcd": "Credit card with wrong check-digit",
        "mem": "Expiry year without expiry month",
        "mey": "Expiry month without expiry year",
        "iem": "Invalid expiry month",
        "iey": "Invalid expiry year",
        "eed": "Expired expiry date",
        "undefined": "Error in inserting data or amount not available",
        "nct": "Error in CVV field",
        "parametri": "Payment gateway error. Go back and try again. If the problem persists, contact support.",
        "threedsisLoading": "3DSecure Form is loading below"
    },
    "IT": {
        "dati": "Dati della carta",
        "textInsertAndPay": "Per i pagamenti inserisci i dati della tua carta di credito",
        "textInsert": "I dati della carta di credito sono obbligatori solo per usufruire del servizio Parking. Puoi saltare questo passaggio ed inserire i dati pi&ugrave; avanti accedendo alla tua area utente.",
        "textChange": "Modifica i dati della carta che vuoi utilizzare per i tuoi acquisti.",
        "cardCheckInfo": "Per verificare la carta saranno addebitati ed immediatamente stornati 10 centesimi.",
        "creditCard": "Carte di Credito",
        "debtCard": "Carte di Debito",
        "ChangeCreditCard": "Modifica",
        "InsertCreditCard": "Inserisci",
        'InsertCreditCardAndPay': 'Inserisci e paga',
        "Pay": "Paga",
        "labelCC": "Numero carta di credito",
        "labelExpiry": "MM/AA",
        "labelCVV": "CVV",
        "labelBuyerName": "Nome sulla carta",
        "labelTokenize": "Memorizza questa carta",
        "amountLabel": "Importo previsto: ",
        "paidAmountLabel": "Importo addebitato: ",
        "maximumAmountLabel": "Importo massimo giornaliero: ",
        "maximumAmountInfo": "SarÃ  prenotato l\'importo massimo e addebitato l\'utilizzo effettivo a chiusura sosta.",
        "additionalTransactionLabel": "Inserimento dati per attestazione transazione",
        "attestationBuyerNameLabel": "Nome e Cognome",
        "emailLabel": "Email*",
        "phoneLabel": "Cellulare*",
        "payAndConfirmParking": "Prosegui e conferma",
        "payAndConfirm": "Prosegui e conferma",
        "Submit": "CONFERMA CARTA DI CREDITO",
        "pText": "REGISTRAZIONE",
        "pText2": "3/4",
        "Per_Ora": "Per ora salto questa sezione",
        "InsertInfo": "Inseriti gli estremi della Carta di Credito ti sar&agrave; addebitato, ed in seguito stornato, 0.10 &euro; per la verifica dei dati.",
        "Piu_informazioni": "PiÃ¹ informazioni",
        "NomeCognome": "Nome sulla carta",
        "NumberCC": "Numero della carta",
        "specifyCC": "Inserisci il numero della carta di credito",
        "specifyCVV": "Inserisci il cvv della carta di credito",
        "specifyExp": "Inserisci la data di scadenza della carta di credito",
        "wcl": "Errore nel numero di cifre della carta",
        "wcd": "Il numero di carta &egrave; sbagliato",
        "mem": "Errore nella data di scadenza della carta",
        "mey": "Errore nella data di scadenza della carta",
        "iem": "Errore nella data di scadenza della carta",
        "iey": "Errore nella data di scadenza della carta",
        "eed": "Questa carta &egrave; scaduta",
        "undefined": "Errore nell'inserimento dei dati o credito non disponibile, per favore controlla e riprova",
        "nct": "Errore nel CVV",
        "parametri": "Errore del gateway di pagamento. Torna indietro e riprova. Se il problema persiste, contatta l'assistenza.",
        "threedsisLoading": "Il modulo 3DSecure verrÃ  caricato qui sotto"
    },
};

export default class GestPayHandler extends Component {
    constructor(props) {
        super(props);
        // console.log("[GestPayHandler] @props", props);
        this.state = {
            l: "EN", // default language
            merchantUrl: Config.merchantURL,
        }
    }

    componentDidMount() {
        const script = document.createElement("script");
        script.src = (this.props.params.bank.test == '1') ? 'https://sandbox.gestpay.net/pagam/JavaScript/js_GestPay.js' : 'https://ecomm.sella.it/pagam/JavaScript/js_GestPay.js';
        script.async = true;
        script.onload = () => this.scriptLoaded();
        document.body.appendChild(script);
        // console.log("[GestPayHandler] @loadScript componentDidMount: ");

    }

    scriptLoaded() {
        if (this.state.scriptLoaded) return;
        this.setState({ scriptLoaded: true });
        const params = this.props.params;
        // console.log("[GestPayHandler] @loadScript params: ", params);

        var parameters = {};
        parameters.userId = params.userId;
        parameters.paymentType = params.paymentType;
        parameters.amountCents = params.amountCents;
        parameters.shopLogin = params.bank.shopLogin;
        parameters.test = params.bank.test;
        parameters.configTest = params.configTest;
        parameters.portal = params.bank.portal + "_" + params.token + "_" + params.paymentType + "_0_" + params.configTest + "_token";
        parameters.checked = params.checked;
        if (params.paymentType == "insertReg" || params.paymentType == "insert" || params.paymentType == "change") {
            parameters.refund = "1";
            parameters.amountCents = 10;
        } else {
            parameters.refund = "0";
        }
        if (params.lang) { this.setState({ l: params.lang }) };
        parameters.CC = params.CC;
        parameters.EXPMM = params.EXPMM;
        parameters.EXPYY = params.EXPYY;
        parameters.CVV2 = params.CVV2;
        parameters.BuyerName = params.BuyerName;
        parameters.callbackURL = params.callbackURL;
        // console.log("[GestPayHandler] @loadScripts parameters: ", parameters);
        this.getMerchantEncryptAndCreatePaymentPage(parameters, this.getMerchantEncryptAndCreatePaymentPageCallback);


    }

    getMerchantEncryptAndCreatePaymentPageCallback = (data) => {
        // console.log("[GestPayHandler] @getMerchantEncryptAndCreatePaymentPageCallback data: ", data);
        const { parameters, encString, SendPaymentResponse } = data;
        let _params = {};




        _params.parameters = JSON.stringify(parameters);
        _params.encString = encString;
        _params.SendPaymentResponse = JSON.stringify(SendPaymentResponse);
        _params.callbackURL = window.location.href.toString().split("?")[0];
        // console.log("[GestPayHandler] @getMerchantEncryptAndCreatePaymentPageCallback _params: ", _params);

        function objectToURIParams(obj) {
            var str = "";
            for (var key in obj) {
                if (str == "") {
                    str = "?";
                } else {
                    str += "&";
                }
                str += key + "=" + encodeURIComponent(obj[key]);
            }
            return str;
        }

        // passing the info to the merchant
        let mypassMrchantUrl = (parameters.test == "1" ? "https://user-test.mypass.ski/new_merchant_v2.html" : "https://user.mypass.ski/new_merchant_v2.html") + objectToURIParams(_params);

        // console.log("[GestPayHandler] @loadScripts merchant_link: ", mypassMrchantUrl);
        window.location.replace(mypassMrchantUrl);



    }


    //@Step1: encryption of payment parameters
    getMerchantEncryptAndCreatePaymentPage(parameters, callback) {
        try {
            const { BrowserEnabled, GestPay } = window;
            // console.log("[GestPayHandler] @loadScript BrowserEnabled: ", BrowserEnabled);
            // console.log("[GestPayHandler] @loadScript GestPay: ", GestPay);
            // console.log("[GestPayHandler] @getMerchantEncryptAndCreatePaymentPage parameters: ", parameters);

            // console.log('GestPayHandler parameters.test is: ', parameters.test, " and type is:", typeof parameters.test);
            // console.log('GestPayHandler parameters: ', parameters);
            let tokenize = "";
            if (parameters.paymentType == "insertAndPay") {
                if (parameters.checked === false) {
                    tokenize = '_token';
                } else {
                    tokenize = '_notoken';
                }
            } else {
                tokenize = '_token';
            }
            let p = parameters.portal;
            if (parameters.paymentType == "insertAndPay" && p.search("undefined") != -1) {
                this.myAlert(t[this.state.l].parametri);
                return false;
            }

            var res = p.replace('_token_', tokenize);
            let url = this.state.merchantUrl +
                "&userId=" + parameters.userId +
                "&payType=" + parameters.paymentType +
                "&amount=" + parameters.amountCents +
                "&portal=" + res +
                "&shopLogin=" + parameters.shopLogin +
                "&refund=" + parameters.refund +
                "&test=" + parameters.test
                ;
            // console.log('GestPayHandler @getMerchantEncryptAndCreatePaymentPage url: ', url);

            this.api(url).then(data => {
                console.log('GestPayHandler @getMerchantEncryptAndCreatePaymentPage #fetch: ', data);
                if (data.shopLogin && data.encString) {
                    console.log('GestPayHandler @before createPaymentPage : ', data.shopLogin, data.encString);
                    console.log("BrowserEnabled: ", BrowserEnabled);
                    if (BrowserEnabled) {
                        GestPay.CreatePaymentPage(data.shopLogin, data.encString, function (CreatePaymentPageResponse) {
                            console.log("GestPayHandler @createPaymentPage CreatePaymentPageResponse:", CreatePaymentPageResponse);
                            if (CreatePaymentPageResponse.ErrorCode == "10") {
                                console.log('GestPayHandler @paymentPageLoadedCallback', 'CreatePaymentPageResponse.ErrorCode == "10"');

                                GestPay.SendPayment({
                                    CC: parameters.CC,
                                    EXPMM: parameters.EXPMM,
                                    EXPYY: parameters.EXPYY,
                                    CVV2: parameters.CVV2,
                                    BuyerName: parameters.BuyerName,
                                },
                                    function (SendPaymentResponse) {
                                        delete parameters.CC;
                                        delete parameters.EXPMM;
                                        delete parameters.EXPYY;
                                        delete parameters.CVV2;
                                        delete parameters.BuyerName;
                                        console.log("GestPayHandler @SendPayment SendPaymentResponse", SendPaymentResponse);
                                        let encString = data.encString;
                                        callback({ parameters, SendPaymentResponse, encString });
                                    }
                                );
                            } else {
                                console.error("Error loading payment page: " + CreatePaymentPageResponse.ErrorCode);
                                alert(CreatePaymentPageResponse.ErrorDescription);
                            }
                        });

                    } else {
                        console.error("SELLA_BROWSER_NOT_SUPPORTED");
                        this.myAlert("SELLA_BROWSER_NOT_SUPPORTED");
                    }
                } else {
                    this.myAlert(data.error.responseText);
                }
            }).catch(e => {
                console.error('GestPayHandler @getMerchantEncryptAndCreatePaymentPage #e: ', e);
                this.myAlert("SELLA_MERCHANT_CALL_ERROR");
            })
        } catch (error) {
            console.error(error);
            this.myAlert("SYSTEM_ERROR");
        }
    }

    myAlert(message) {
        alert(message);
        this.props.callback();
    }

    api(url) {
        // console.log('GestPayHandler @api #fetch: ', url);
        try {
            return fetch(
                url,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                }
            )
                .then(response => this.checkStatus(response))
                .then(response_2 => {
                    // console.log('GestPayHandler @api #response: ', response_2);
                    return response_2;
                })
        } catch (e) {
            console.warn('Network exception: ', e);
            if (e.message.indexOf("Network request failed") >= 0) {
                return null;
            }
        }
    }

    checkStatus(response) {
        // console.log('GestPayHandler @checkStatus #response: ', response);
        if (response.status == 401) { // unauthorized
            // console.log("[" + response.status + "] checkStatus", response);
        }
        return response.json();
    }

    render() {
        return (null);
    }

}


// WEBPACK FOOTER //
// ./src/assets/components/bank/GestPayHandler.js